import {
  Align,
  Arrange,
  Button,
  IconButton,
  Link,
  Spacer,
  SvgClose,
} from '@loomhq/lens';
import cn from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  requestVideoPlayerEnterFullScreen,
  requestVideoPlayerLeaveFullScreen,
} from 'actions/videoPlayer';
import { EMAIL_SIGNUP_BUTTON_CLICKED } from 'constants/events';
import { LOOM_URI, SIGNUP_PAGE } from 'constants/routes';
import { selectFullscreen } from 'selectors/videoPlayer';
import { usePauseNudgeState } from 'utilities/localStorage/storageIncentives';

import * as analytics from '../../../../utilities/analytics';

import styles from './styles.module.less';

const ButtonAction = () => {
  function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    window.open(SIGNUP_PAGE, '_blank');

    analytics.track(EMAIL_SIGNUP_BUTTON_CLICKED, {
      source: 'Pause Video Nudge',
    });
  }

  return (
    <Button variant="primary" onClick={e => handleClick(e)}>
      Get Loom for Free
    </Button>
  );
};

const FullLengthButtonCta = () => {
  function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    window.open(SIGNUP_PAGE, '_blank');

    analytics.track(EMAIL_SIGNUP_BUTTON_CLICKED, {
      source: 'Pause Video Nudge',
    });
  }

  return (
    <Align className={styles.fullLengthSignupCta} alignment="bottomCenter">
      <button onClick={e => handleClick(e)} className={styles.roundedButton}>
        Sign up for free
      </button>
    </Align>
  );
};

function PauseNudge({
  sharePageFlagValue,
  embedFlagValue,
  isMainVideoOnSharePage,
  onBackgroundClick,
}) {
  const dispatch = useDispatch();
  const isFullscreen = useSelector(selectFullscreen);

  const [canShowPauseNudge, setShowPauseNudge] = usePauseNudgeState();
  const { owner_name, id: videoId } = window.loomSSRVideo;
  const videoLink = videoId ? `${LOOM_URI}/share/${videoId}` : null;

  let content = null;

  if (sharePageFlagValue === 'variant-1' || embedFlagValue === 'variant-1') {
    // Don't show nudge if it's been dismissed
    if (canShowPauseNudge === false) {
      return null;
    }
  }

  const onWatchOnSharePageClick = e => {
    e.preventDefault();
    e.stopPropagation();
    window.open(videoLink, '_blank');
  };

  // share page variant 1
  if (sharePageFlagValue === 'variant-1') {
    const title = owner_name
      ? `Sign up to let ${owner_name} know you saw their loom`
      : `Sign up to let your teammate know you saw their loom`;

    content = (
      <Arrange gap="medium" alignItems="center" rows={['1rem', '4rem', 'auto']}>
        <h1 className={styles.nudgeTitle}>{title}</h1>
        <ButtonAction />
      </Arrange>
    );
  }

  // embed variant 1
  if (embedFlagValue === 'variant-1') {
    content = (
      <Arrange
        gap="medium"
        alignItems="center"
        justifyContent="center"
        alignContent="center"
        rows={['1rem', '4rem', '1rem']}
      >
        <h1 className={styles.nudgeTitle}>
          Get Loom to become faster than typing.
        </h1>
        <ButtonAction />
        {videoLink && (
          <Align alignment="center">
            <Link
              className={styles.nudgeLink}
              onClick={onWatchOnSharePageClick}
            >
              Continue watching on loom.com
            </Link>
          </Align>
        )}
      </Arrange>
    );
  }

  return (
    <div
      className={cn('watch-again-cta', styles.pauseNudgeContainer)}
      onClick={onBackgroundClick}
      style={{ cursor: 'default' }}
      onDoubleClick={() =>
        isFullscreen
          ? dispatch(requestVideoPlayerLeaveFullScreen())
          : dispatch(requestVideoPlayerEnterFullScreen())
      }
    >
      {(embedFlagValue === 'variant-1' ||
        sharePageFlagValue === 'variant-1') && (
        <div className={styles.pauseNudgeModalContainer}>
          <Arrange
            gap="small"
            justifyContent="stretch"
            rows={['2rem', '5rem', !isMainVideoOnSharePage ? '2rem' : 'auto']}
          >
            <Align alignment="topRight">
              <IconButton
                altText="Close"
                color="black"
                icon={<SvgClose />}
                onClick={() => setShowPauseNudge(false)}
              />
            </Align>
            <div className={styles.pauseNudgeModalContainerContent}>
              <Spacer top={5} />
              {content}
            </div>
          </Arrange>
        </div>
      )}
      {(embedFlagValue === 'variant-2' ||
        sharePageFlagValue === 'variant-2') && <FullLengthButtonCta />}
    </div>
  );
}

export default PauseNudge;
